import { render, staticRenderFns } from "./clientGroupDetail.vue?vue&type=template&id=680c212e&scoped=true"
import script from "./clientGroupDetail.vue?vue&type=script&lang=js"
export * from "./clientGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./clientGroupDetail.vue?vue&type=style&index=0&id=680c212e&prod&scoped=true&lang=css"
import style1 from "./clientGroupDetail.vue?vue&type=style&index=1&id=680c212e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c212e",
  null
  
)

export default component.exports